module.exports = __webpack_public_path__ + "img/man--980.d8e654f.jpg";